import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import { isDp3Policy } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('protect-high-value-items-section', []);

interface ProtectHighValueItemsSectionController extends angular.IStrictController {
    title: string;
    description: string;
    icon: string;
    policyInfo: CustomerPolicyInfo;
}

module.component('protectHighValueItemsSection', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(this: ProtectHighValueItemsSectionController, $element: angular.IAugmentedJQuery) {
        this.$onInit = () => {
            this.title = 'Protect your high value items';
            this.description = `If you have items over $2,500, such as engagement rings, bikes, or golf clubs, we'd
                suggest adding them to your policy to make sure they're fully covered. To add them simply call us at
                1-800-585-0705 or click below and we'll reach out to you.`;
            this.icon = 'ring';

            if (isDp3Policy(this.policyInfo)) {
                $element.addClass('ng-hide');
            }
        };
    }
});

export { module };
